<style>
.setpsd {
  box-sizing: border-box;
  padding: 0 80px;
  background: #fff;
  overflow: hidden;
  padding-bottom: 300px;
  width: 1200px;
  height: 700px;
}

.set-form {
  margin-top: 100px;
}

.set-input {
  width: 360px !important;
}

.setpsd .el-form-item {
  margin-bottom: 25px;
}

.setpsd .el-input__inner {
  height: 45px;
  line-height: 45px;
  border-radius: 23px;
}
.setpsd .sendCode {
  width: 140px;
  height: 45px;
  line-height: 45px;
  display: inline-block;
  position: absolute;
  margin-left: -140px;
  border-radius: 25px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.setpsd .sendCode.btn-green {
  background: #2ecfa7;
}
.setpsd .sendCode.btn-grey {
  background: #abb1c3;
}

.set-submit {
  margin-top: 45px;
  margin-left: 250px;
}

.update-psd {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}
.tips {
  color: #f83b56;
  text-align: center;
  margin: 20px 0;
}

.setpsd .el-form-item__label,
.setpsd .el-form-item__error {
  margin-left: 250px;
}
.set-submit .el-button {
  width: 115px!important;
  height: 46px;
}
</style>
<template>
  <div>
    <div class="content setpsd">
      <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="120px"
               class="demo-ruleForm set-form">
        <div class="update-psd">重置消费密码</div>
        <div class="tips">温馨提示：密码必须由顾客本人重设，店员不可代劳。否则密码泄露后的损失由店员承担。</div>
        <el-form-item label="短信验证码：" prop="vcode" ref="resetVcode">
            <el-input type="text" v-model="ruleForm2.vcode" autocomplete="off" auto-complete="off" class="set-input" placeholder="请输入短信验证码"></el-input>
            <div class="sendCode btn-green" @click="sendVcode">发送验证码</div>
            <div class="el-form-item__error" v-if="errorFlag">短信验证码已发送至会员手机{{memInfo.tel.substr(0,3)+"****"+memInfo.tel.substr(7)}}上， 请顾客输入。</div>
        </el-form-item>
        <el-form-item label="重设密码：" prop="pass">
          <el-input type="password" v-model="ruleForm2.pass" autocomplete="off" auto-complete="off" class="set-input" placeholder="请输入6位数密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="checkPass">
          <el-input type="password" v-model="ruleForm2.checkPass" autocomplete="off" auto-complete="off" class="set-input" placeholder="请再次输入6位数密码"></el-input>
        </el-form-item>
        <el-form-item class="set-submit">
            <el-button class="darkBtn" @click="resetForm('ruleForm2')">取消</el-button>
            <el-button class="redBtn" @click="submitForm('ruleForm2')">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { sendCode, updateMemPsd } from "@/api";
import CryptoJS from 'crypto-js'

export default {
  data() {
    var checkoldPass = (rule, value, callback) => {
      var reg = /^\+?[0-9][0-9]*$/;
      if (value === "") {
        callback(new Error("请输入验证码"));
        this.errorFlag = false;
      } else if (!reg.test(value)) {
        callback(new Error("验证码格式为数字，请输入正确的验证码"));
        this.errorFlag = false;
      } else if (value.length < 6) {
        callback(new Error("验证码不正确"));
        this.errorFlag = false;
      } else if (value.length > 6) {
        callback(new Error("验证码长度只可以是6位"));
        this.errorFlag = false;
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      var reg = /^\+?[0-9][0-9]*$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为数字，请设置正确格式的密码"));
      } else if (value.length < 6) {
        callback(new Error("密码太短"));
      } else if (value.length > 6) {
        callback(new Error("密码长度只可以是6位"));
      } else {
        if (this.ruleForm2.checkPass !== "") {
          this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      var reg = /^\+?[0-9][0-9]*$/;
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为数字，请设置正确格式的密码"));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error("两次密码输入不一致！"));
      } else if (value.length < 6) {
        callback(new Error("密码太短"));
      } else if (value.length > 6) {
        callback(new Error("密码长度只可以是6位"));
      } else {
        callback();
      }
    };
    return {
      ruleForm2: {
        vcode: "",
        pass: "",
        checkPass: ""
      },
      rules2: {
        vcode: [{required: true, validator: checkoldPass, trigger: "blur" }],
        pass: [{ required: true, validator: validatePass, trigger: "blur" }],
        checkPass: [{ required: true, validator: validatePass2, trigger: "blur" }]
      },
      errorFlag: false,
      clickSwitch: true,
      memInfo: JSON.parse(sessionStorage.getItem("memInfo"))
    };
  },
  created() {
    if(this.$store.state.vcode){
      this.sendVcode();
      this.$store.commit("setVcode", false);//取消列表页状态
    }
  },
  methods: {
    operaEntryDES(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("VIP20198888*7*6*5*4**88882088VIP");
      var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    sendVcode() {
      //   发送验证码
      if (this.clickSwitch) {
        let sec = 60;

        sendCode({
          phone: this.memInfo.tel
        }).then(res => {
          if (res.code == 1) {
            $(".sendCode")
              .removeClass("btn-green")
              .addClass("btn-grey");
            $(".sendCode").html("重新发送(" + sec + "S)");
            this.errorFlag = true;
            this.$refs.resetVcode.clearValidate();

            let setTime = setInterval(() => {
              if (sec <= 0) {
                clearInterval(setTime);
                $(".sendCode").html("发送验证码");
                $(".sendCode")
                  .removeClass("btn-grey")
                  .addClass("btn-green");
                this.clickSwitch = true;
                this.errorFlag = false;
                return;
              } else {
                sec--;
                $(".sendCode").html("重新发送(" + sec + "S)");
                this.clickSwitch = false;
              }
            }, 1000);
          }
          this.$message({
            type: res.code == 1 ? "success" : "error",
            message: res.msg
          });
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let postData = {
            memberId: this.memInfo.id,
            smsCode: this.ruleForm2.vcode,
            updateFlag: "2",
            passwordOff: this.operaEntryDES(this.ruleForm2.pass),
            phone: this.memInfo.tel
          };

          const date = updateMemPsd(postData);
          date
            .then(res => {
              this.$message({
                message: res.msg,
                type: res.code == 1 ? "success" : "error"
              });
              if (res.code == 1) {
                sessionStorage.removeItem("memInfo");
                this.$store.commit("delete_tabs", "/basicDataCenter/resetPsd");
                this.$router.push("/basicDataCenter/baseInfo");
              }
            })
            .catch(error => {
              this.$message({
                message: "网络连接失败，请稍后再试",
                type: "error"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/basicDataCenter/resetPsd.vue